import { cn } from "@wags/ui/ui-utils";
import { SpriteLoop } from "./sprite-loop";

type MascotState = "idle" | "thinking";

const IDLE_SPRITE_WIDTH = 192;
const IDLE_SPRITE_HEIGHT = 192;
export const MASCOT_IDLE_ASPECT = IDLE_SPRITE_WIDTH / IDLE_SPRITE_HEIGHT;

export function MascotAvatar({
    state = "idle",
    size = 30,
    animated = true,
    className,
}: {
    state?: MascotState;
    size?: number;

    animated?: boolean;
    className?: string;
}) {
    const box = cn("pointer-events-none shrink-0", className);
    return state === "thinking" ? (
        <SpriteLoop
            src="/animations/kits-thinking-sprite.png"
            frames={7}
            aspectRatio="249 / 182"
            duration="var(--kits-thinking-duration, 0.9s)"
            role="img"
            label="Kits"
            animate={animated}
            className={box}
            style={{ height: size }}
        />
    ) : (
        <SpriteLoop
            src="/animations/kits-idle-sprite.png"
            frames={8}
            aspectRatio={`${IDLE_SPRITE_WIDTH} / ${IDLE_SPRITE_HEIGHT}`}
            duration="var(--kits-idle-duration, 2.5s)"
            role="img"
            label="Kits"
            animate={animated}
            className={box}
            style={{ height: size }}
        />
    );
}
